var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import PBService from "@irati/utils/services";
import client from "@irati/utils/services/apollo";
import loginGhostTokenForBusinessQuery, { loginGhostTokenForBusinessKey } from "./queries/loginGhostTokenForBusiness";
import loginGhostQuery, { loginGhostKey } from "./queries/loginGhost";
import tokens from "./tokens";
import AuthStream from "../streams/auth";
var GhostLogin = /** @class */ (function (_super) {
    __extends(GhostLogin, _super);
    function GhostLogin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GhostLogin.prototype.getTokenForBusiness = function (businessId, userId, options) {
        if (options === void 0) { options = {}; }
        var variables = { businessId: businessId, userId: userId };
        return client
            .query(__assign(__assign({}, options), { fetchPolicy: "no-cache", query: loginGhostTokenForBusinessQuery, variables: variables }))
            .then(function (_a) {
            var data = _a.data;
            return data[loginGhostTokenForBusinessKey];
        });
    };
    GhostLogin.prototype.login = function (accessToken, options) {
        if (options === void 0) { options = {}; }
        tokens.set({ accessToken: accessToken });
        return client.query(__assign(__assign({}, options), { query: loginGhostQuery })).then(function (_a) {
            var data = _a.data;
            var _b = data[loginGhostKey], user = _b.user, business = _b.business;
            return AuthStream.start({ user: user, business: business });
        });
    };
    return GhostLogin;
}(PBService));
export default new GhostLogin({ errorHandlers: [] });
